import { uidDerivation } from "../../utils/uid-derivation.js";
import { coreEngine } from "../engine.js";
import { parsers } from "./parsers.js";
// Import action component to ensure it's registered before creating action instances
import { action } from "../../components/action.js";

class ActionParser {
  constructor() {
    parsers.addType("config:action", this._applyActions.bind(this));
  }

  _applyActions(config) {
    for (const actionConfig of config.actions) {
      this._populateActionUids(actionConfig);
      coreEngine.create(actionConfig);
    }
  }

  _populateActionUids(action) {
    const executionArray = action.execute;
    const usedUids = new Set();
    for (const instance of executionArray) {
      if (!instance.uid) {
        instance.uid = uidDerivation.deriveUid(instance, (candidate) => usedUids.has(candidate));
      }
      usedUids.add(instance.uid);
    }
  }
}

const actionParser = new ActionParser();
export { ActionParser, actionParser };
